var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6V5C6 3.34315 7.34315 2 9 2H11C12.6569 2 14 3.34315 14 5V6H16C17.1046 6 18 6.89543 18 8V8.66504C18 8.94118 17.7761 9.16504 17.5 9.16504H2.5C2.22386 9.16504 2 8.94118 2 8.66504V8C2 6.89543 2.89543 6 4 6H6ZM8 5C8 4.44772 8.44772 4 9 4H11C11.5523 4 12 4.44772 12 5V6H8V5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.665C18 10.3889 17.7761 10.165 17.5 10.165H12.5C12.2239 10.165 12 10.3889 12 10.665V11C12 11.5523 11.5523 12 11 12H9C8.44772 12 8 11.5523 8 11V10.665C8 10.3889 7.77614 10.165 7.5 10.165H2.5C2.22386 10.165 2 10.3889 2 10.665V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V10.665Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.7bb50d935b81df6ff2c50ed97632cdbb.svg";
export { ForwardRef as ReactComponent };